import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import partition from 'lodash/partition';

import {MPCustomEvent} from '../models/events';

export const ELEMENTS_BY_CSS_CLASS = {
  CUSTOM_EVENTS_MODAL_CONTENT: `custom-event-modal-content-js`,
  EVENT_DROPDOWN_PLACEHOLDER: `event-dropdown-placeholder-js`,
  PROPERTY_FILTER_DROPDOWN_PLACEHOLDER: `property-filter-dropdown-placeholder-js`,
};

export function getResolvedCustomEvents(customEvents) {
  const resolvedCustomEventsMap = new Map();
  const unresolvedCustomEvents = customEvents.filter((ev) => !ev.deleted).map(MPCustomEvent.fromSerializedCustomEvent);
  const customEventIdSet = new Set(unresolvedCustomEvents.map((ev) => ev.id));
  const getCustomEventId = (event) => Number(event.split(`:`)[1]);
  const isUnresolvedCustomEventSelector = ({event}) => {
    return (
      isString(event) &&
      event.startsWith(MPCustomEvent.CUSTOM_EVENT_PREFIX) &&
      customEventIdSet.has(getCustomEventId(event))
    );
  };

  let resolvedCustomEvents = [];
  let unresolved = unresolvedCustomEvents;
  let resolved;
  while (resolvedCustomEventsMap.size < customEventIdSet.size) {
    [unresolved, resolved] = partition(unresolved, (ce) => ce.eventSelectors.some(isUnresolvedCustomEventSelector));
    if (isEmpty(resolved)) {
      console.warn(`Custom events cycle detected!`);
      break;
    }

    resolved.forEach((ce) => resolvedCustomEventsMap.set(ce.id, ce));
    unresolved.forEach((ce) => {
      // replace each unresolved selector with its resolved custom event model
      ce.eventSelectors.forEach((selector) => {
        if (isUnresolvedCustomEventSelector(selector)) {
          const id = getCustomEventId(selector.event);
          if (resolvedCustomEventsMap.has(id)) {
            selector.event = resolvedCustomEventsMap.get(id);
          }
        }
      });
    });

    resolvedCustomEvents = resolvedCustomEvents.concat(resolved);
  }

  return resolvedCustomEvents;
}

/**
 * Naive (non-optimized) cycle detection -- iterate through each custom event, and return each event
 * whose graph traversal reaches the target custom event, indicating that a cycle
 * would be created if the target custom event took a dependency on that event.
 * @param {*} target
 * @param {*} allCustomEvents
 */
export function cycleCreatingCustomEvents(target, allCustomEvents) {
  let cycleCreatingEvents = [];
  allCustomEvents.forEach((customEvent) => {
    const visited = new Set();
    const unvisited = new Set([customEvent]);
    while (unvisited.size > 0) {
      const current = unvisited.values().next().value;
      if (current.id === target.id) {
        cycleCreatingEvents = [...cycleCreatingEvents, customEvent];
        break;
      } else {
        current.eventSelectors
          .filter((eventSelector) => eventSelector.event.id && !visited.has(eventSelector.event.id))
          .forEach((eventSelector) => unvisited.add(eventSelector.event));
        visited.add(current.id);
        unvisited.delete(current);
      }
    }
  });

  return cycleCreatingEvents;
}
